var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.get_FlagServicesShowBookingnoSearchResults
    ? _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "block", attrs: { id: "contentElementBookingno" } },
            [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("sdr-breadcrumbs", {
                    attrs: { active_item: "first", module: _vm.modulo },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "container shortcode travel-ideas" }, [
                  _c(
                    "h1",
                    {
                      staticClass: "idea-title",
                      staticStyle: { "margin-bottom": "30px" },
                    },
                    [
                      _vm._m(0),
                      _vm._v(_vm._s(_vm.headline_step1[_vm.getCurrentLocale])),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-8 col-md-9" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tab-container",
                      attrs: { id: "flight-features" },
                    },
                    [
                      _c("ul", { staticClass: "tabs" }, [
                        _c("li", { staticClass: "active" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "#flight-details",
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.tab_flightdetails[_vm.getCurrentLocale]
                                )
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tab-content" }, [
                        _c(
                          "div",
                          {
                            staticClass: "tab-pane fade in active",
                            attrs: { id: "flight-details" },
                          },
                          [
                            _c("sdr-bookingno-flight-details", {
                              attrs: { flightdirection: "outward" },
                            }),
                            _vm._v(" "),
                            _vm.get_ServicesBookingnoHasReturnFlight
                              ? _c(
                                  "div",
                                  [
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("hr"),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("sdr-bookingno-flight-details", {
                                      attrs: { flightdirection: "return" },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-large icon-check uppercase full-width",
                      class: {
                        sundairsrvcs: _vm.modulo === "services",
                        "icon-check3": _vm.modulo === "services",
                      },
                      attrs: { type: "submit" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.call_nextCalls()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sidebar col-sms-6 col-sm-4 col-md-3 topDistance",
                  },
                  [
                    _c("h2", [_vm._v(" ")]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "search-results-title" }, [
                      _c("i", { staticClass: "soap-icon-search" }),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.get_ServicesBookingnoPassengersCountAll)
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.resultsshown[_vm.getCurrentLocale]) +
                          "."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("sdr-contact-box"),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-arrow-right circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }